module.exports = __webpack_public_path__ + "0b53fb0a67a35c5aaa548c8fdc44a5cc.jpg";